
// region JS Imports

// region External Modules
import $ from "jquery"
import u from "umbrellajs"
import {
  RequestIdleCallbackPayload,
} from "plugins/request-animation-frame-polyfill"
// endregion External Modules

// Private Modules
// Private Modules

// region Public Components
// endregion Public Components

// region Private Components
import {
  Factory as EventsFactory,
} from "./events/index"
// endregion Private Components

// endregion JS Imports


const CELL_CLASS_NAME = "cell--listings--contact--button"
const CELL_INITIALIZED_CLASS_NAME = `${CELL_CLASS_NAME}--js-spacious-initialized`

// Returns whether something left not initialized
const init = (deadline?: RequestIdleCallbackPayload): boolean => {
  // using `#some` to allow short circuit (by returning true)
  return u(`.${CELL_CLASS_NAME}`).nodes.some((el) => {
    // Assume 5ms require for 1 contact button to be initialized
    if (deadline != null && deadline.timeRemaining() <= 5.0) return true

    const $el = $(el)

    if (el.classList.contains(CELL_INITIALIZED_CLASS_NAME)) { return }
    el.classList.add(CELL_INITIALIZED_CLASS_NAME)

    EventsFactory.create({
      main: $el,
    })
  })
}

// Returns whether something left not initialized
const onLoad = (deadline: RequestIdleCallbackPayload): boolean => {
  return init(deadline)
}

export default {
  init,
  onLoad,
}
